import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Modal as AntModal,
  Input,
  Popover,
  Tabs,
  Button,
  Badge,
  theme,
  Select,
  Tooltip,
  Checkbox,
  Popconfirm,
  Space,
  DatePicker,
  Typography,
  message,
  Switch,
  Radio
} from "antd";
import "./CreateTaskModal.css";
import Config from '../../config.json'
import { Row, Col} from "reactstrap";
import dayjs from "dayjs"; 
import { setNotificationFlag } from "../../Context/ReduxContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faUser,
  faClock,
  faFolder,
  faPaperclip,
  faCodeBranch,
  faArrowLeft,
  faTimes,
  faCheck,
  faAngleRight,
  faPlus,
  faMinus,
  faTrashAlt,
  faFilter,
  faArrowDown,
  faArrowUp,
  faComments,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { AppDataRequired } from "../../App";
import { ActivitySection } from "./AddTaskTabs/ActivitySection";
import AppContext from "../../Context/AppContext";
import AwsServerService from "../../common/util/AwsServerService";
import _ from 'lodash';
import swal from "sweetalert";
import {convertToUSTime} from "../../components/HR/TimeClock/Util";
import { Option } from "antd/es/mentions";
import { i, number } from "mathjs";
import { Socket } from "../../Context/AppActions";
import { StatusTimeline } from "./StatusTimeline/StatusTimeline";
import ReminderForTasks from "./ViewPipelinesTabs/ReminderForTasks";
import { useDispatch, useSelector } from "react-redux";
import EmailChatSection from "./ViewPipelinesTabs/EmailChatSection";
import TaskCommentSection from "./TaskCommentSection";
const { Search } = Input;
const { OptGroup } = Select;

const TaskSidebarContentRenderer = ({
   taskModalState, 
   sidebarOptions, 
   activitySection, 
   selectedTable, 
   refreshData, 
   allTasksAndSubtasks,
   setRefreshTasksSubtasks,
   setLoader,
   isSubTaskView,
   taskData,
   statusTimeline,
   getParams,
   location,
   handleNotificationHyperlink,
   viewTaskData,
   lookUpDeal,
   allPipelineData,
   allCacheUserRoles,
   allCacheRoles,
   handleHistoryAdd,
   viewTaskFunction,
   taskListComment
}) =>{
    const { AllUsers } = useContext(AppDataRequired);
    const AppData = useContext(AppContext);
    const { dispatch } = AppData || {};
    const [userOptions, setUserOptions] = useState([]);
    const [refreshReminder, setRefreshReminder] = useState(false);
    let AllDeals = useSelector((state) => state.AppReduxContext.AllDeals || []);
    const userInfo = JSON.parse(localStorage.getItem('userinfo'));
    useEffect(
        (e) => {
        if (AllUsers && AllUsers.length > 0) {
            let arr = AllUsers.map((d) => {
            return {
                label: d.full_name,
                value: d.zuid,
                email:d.email,
                subvalue: `${d.first_name[0]?.toUpperCase()}${d.last_name[0]?.toUpperCase()}`,
            };
            });
            setUserOptions(arr);
        }
        },
        [AllUsers]
    );
    const timeline = useRef(null);
    const [scrollBottom, setScrollBottom] = useState(0);
    useEffect(() => {
        // Scroll to the bottom when items update
        if (timeline.current) {
          timeline.current.scrollTop = timeline.current.scrollHeight;
        }
      }, [scrollBottom]);
     const [messageBehavior, setMessageBehavior] = useState("nextLineOnEnter");
      const handleMessageBehaviorChange = (e) => {
        setMessageBehavior(e.target.value);
      };
    const [activityFilter, setActivityFilter] = useState({Sort:"DESC",SearchText:''});
    const [selectedActivityFilter, setSelectedActivityFilter] = useState([]);

    const handleFilterChange = (checkedValues) => {
        setSelectedActivityFilter(checkedValues);
      };
      const filterActivityPopOver=()=>{ 
        const filterOptions = [
          { value: 'TASK', label: 'Task' },
          { value: 'ASSIGNEE', label: 'Assignee' },
          { value: 'SUPERVISOR', label: 'Project Manager' },
          { value: 'PRIORITY', label: 'Priority' },
          { value: 'STATUS', label: 'Status' },
          { value: 'BLUEPRINT', label: 'Blueprint' },
          // { value: 'COMMENT', label: 'Comments' },
          { value: 'DEPENDENCY', label: 'Dependency' },
          { value: 'TIME TRACKER', label: 'Time Tracks' },
          { value: 'SUBTASK', label: 'Sub Task' },
        ]; 
          return (
          <div className="filter-options">
            <Checkbox.Group
              value={selectedActivityFilter}
              onChange={handleFilterChange}
            >
              <Space direction="vertical">
                {filterOptions.map(option => (
                  <Checkbox key={option.value} value={option.value}>
                    {option.label}
                  </Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          </div>
        );
    }
    function openTaskFromActivity(data){
        setRefreshTasksSubtasks(true);
        const [type,id]=[...data];
        setLoader(true)
        if(selectedTable=='tasks'){
        if(type=='Tasks'){
          AwsServerService.getTaskById(number(id)).then(res=>{
            let k=res[0]?.taskInfo;
            if(k){
              handleHistoryAdd();
              viewTaskFunction(k,"TASK");
              setLoader(false)
            }
          }).catch(e=>{
            setLoader(false);
          }) 
        }else{
          AwsServerService.getSubTaskBySubTaskId(number(id)).then(res=>{
            let k=res[0]?.taskInfo;
            if(k){
              handleHistoryAdd();
              viewTaskFunction(k,"SUBTASK");
              setLoader(false);
            }
          }).catch(e=>{
            setLoader(false);
          })   
        }
      }else{
          if(type=='Tasks'){
            AwsServerService.getTaskByIdFromTemplate(number(id)).then(res=>{
              let k= res[0]?.taskInfo || res[0][0].taskInfo; 
              if(k){ 
                handleHistoryAdd();
                viewTaskFunction(k,"TASK"); 
                setLoader(false); 
              }
            }) 
          }else{
            AwsServerService.getSubTaskBySubTaskIdFromTemplate(number(id)).then(res=>{
              let k= res[0]?.taskInfo || res[0][0].taskInfo; 
              if(k){ 
                handleHistoryAdd();
                viewTaskFunction(k,"SUBTASK"); 
                setLoader(false) 
              }
            }) 
          } 
        }
      }
    const [reminderVisible, setReminderVisible] = useState(false); 
    const [formData, setFormData] = useState({
        sendReminderAs:'Popup',
        attendees:[],
        when:null,
        "Custom date and time":{date:new Date(),time:"00:00"}, 
        note:''
      });
      useEffect(()=>{ 
        setFormData({...formData,"Custom date and time":{date:new Date(),time:"00:00"}})
        console.log("formData.when?.label",formData.when?.label);
        
      },[formData.when])

    const saveReminder =async (data) => {    
        
        let id='';
          if(taskData?.hasOwnProperty('SubTaskROWID')){
            id = taskData.SubTaskROWID;
          }else{
            id= taskData.TaskROWID;
          } 
            let payload = {
              // "type": data.reminders.action,
              "module": "Task",
              "messageId": id,
              "reminderHeading": `Reminder for task "${taskData.TaskName}"`,
              "userEmail": userInfo.email_id,
              "sendAs": 'popup', 
              "status":false
            }; 
              payload.reminderType = "after"; 
              let str=dayjs(data["Custom date and time"]?.date).format("MM/DD/YYYY")+" "+data["Custom date and time"]?.time;
              payload.reminderTime=convertToUSTime(new Date(str)); 
            if(data.attendees?.length>0){
              let attendees= userOptions?.filter(item => data.attendees?.includes(item.value))
              .map(item => item.email).join(", "); 
              payload.attendees = attendees;
            }else{
              payload.attendees = userInfo.email_id ;
            }
               
            await AwsServerService.AddReminders(payload).then(res=>{
          //  dispatch(setIsReminderPopupOpen({status:false,email:null})); 
           swal("Success!", "Reminder added successfully!.", "success");
           setRefreshReminder(true);
           dispatch(Socket({trigger:"Refresh_Reminder_List",data:null}))
           dispatch(Socket({trigger:"Reminders_Notification",data:null})) 
           }) 
      }  

      const getDatePickerValue = (date) => {
            try {
              let d = date
              if (d) {
                return dayjs(new Date(d));
              } else {
                return null;
              }
            } catch (error) { }
        }
        
    const reminderContent = ()=> (
        <div style={{ padding: 10, background:'#edf0f4',fontSize: 'small', fontWeight: '500' }}>
          <div className='popupHeader'> Add Reminder </div>
          {/* <div className='checkBoxForReminder'>
            <Checkbox 
              checked={formData.beforeStart} 
              onChange={(e) => handleChange('beforeStart', e.target.checked)}
            >
              Before Start
            </Checkbox> 
            <Checkbox 
              checked={formData.beforeExpiry} 
              onChange={(e) => handleChange('beforeExpiry', e.target.checked)}
            >
              Before Expiry
            </Checkbox>
          </div> */}
          <div className='checkBoxForReminder'>
            Who :
                   <Select
                    mode="multiple"
                    rootClassName="attendeWrapper"
                    placeholder="Add participants"
                    style={{ mixWidth: '30rem' }}
                    onChange={value=>setFormData({...formData,'attendees':value})} 
                    >
                      <OptGroup label="Users">
                    {userOptions.map(e=>(<Option value={e.value}>{e.label}</Option>))}
                    </OptGroup>
                    <OptGroup label="User Roles">
                    {allCacheUserRoles?.map((userRole) => {
                        const matchingRole = allCacheRoles.find((role) => role.ROWID === userRole.RoleId);
                        return matchingRole ? (
                          <Option key={userRole.RoleId} value={matchingRole.RoleName}>
                            {matchingRole.RoleName}
                          </Option>
                        ) : null;
                      })
                      .filter(Boolean)}
                    </OptGroup>
                  </Select>
          </div>
          {/* <div style={{ marginTop: 10,display:'flex',alignItems:'center' }}>
             When: 
            <Selectt 
              styles={{control: (provided) => ({
                ...provided,
                height: 33,  
                minHeight: 33,
                display: 'flex',
                alignItems: 'center', 
              }),valueContainer: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center', // Center the selected value vertically
                justifyContent: 'center', // Optional: center the content horizontally if needed
              }),
              singleValue: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center', // Center the selected value text vertically
              }),
              indicatorContainer: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center', // Center the dropdown and clear icons
              }),dropdownIndicator: (provided) => ({
                ...provided,
                padding: 4, // Adjust padding of the dropdown icon
                display: 'flex',
                alignItems: 'center', // Center the dropdown icon vertically
              }),
              clearIndicator: (provided) => ({
                ...provided,
                padding: 4, // Adjust padding of the clear icon
                display: 'flex',
                alignItems: 'center', // Center the clear icon vertically
              })}}
              value={formData.when}
              closeMenuOnSelect={true}
              options={ScheduleArr}
              onChange={(value) => handleChange('when', value)}
              rootClassName='selectForTaskReminder'
              className='selectForTaskReminder'
            />
          </div>
          {formData.when?.label=="Custom date and time"&& */}
           {<div>
              <div className='dateTimeForTaskReminder'>
              Select Date : 
              <DatePicker
                allowClear
                portalId="root"
                format="MM/DD/YYYY"
                value={getDatePickerValue(formData['Custom date and time'].date)} 
                placeholderText="Select a date"
                popperClassName="ag-custom-component-popup" 
                className={`form-control form-control-sm `}  
                onChange={(date) =>{
                  let dateTime=formData['Custom date and time'];
                  dateTime={...dateTime,'date':new Date(date)}
                  setFormData({...formData,'Custom date and time':dateTime}) 
                }}  
              /> 
              </div>
              <div className='dateTimeForTaskReminder'>
              Select Time :
              <input 
                type="time"
                className="form-control form-control-sm"
                format="HH:mm A" 
                style={{height:'2.2rem',width: '60%',marginLeft:'2.4em',fontWeight: '700'}}  
                onChange={(e) =>{
                  let dateTime=formData['Custom date and time'];
                  dateTime={...dateTime,'time':e.currentTarget.value}
                  setFormData({...formData,'Custom date and time':dateTime}) 
                  }}
                value={formData?.['Custom date and time']?.time}
              />
              </div>
              </div>}
          {/* <div style={{ marginTop: 10,marginBottom:10 }}>
            <Checkbox 
              checked={formData.remindSupervisor} 
              onChange={(e) => handleChange('remindSupervisor', e.target.checked)}
            >
              Remind Supervisor
            </Checkbox>
          </div> */}
          <div className='buttonsForTaskRem'><Button type='primary' onClick={()=>setReminderVisible(false)}>Cancel</Button> <Button type='primary' onClick={()=>{
            saveReminder(formData)
            setReminderVisible(false)
          }}>Set Reminder</Button></div>
        </div>
      );
      
    return (
        <Col className="Task-Activity-Wrapper" sm={5}>
            <div className="Activity-Header">
                <span className="header">{sidebarOptions[activitySection]?.key}</span>
                {activitySection==0 && <div className="additionalFeaturesOfActivity">
                <span className="header">
                <Search placeholder="Input search text" 
                allowClear={true}
                onSearch={(text)=>setActivityFilter({...activityFilter,SearchText:text})}
                onChange={(e)=>{
                if(e.currentTarget.value==''){
                    setActivityFilter({...activityFilter,SearchText:''})}}
                }
                className="inputForActivitySearch"
                style={{ width: 200 }} />
                </span> 
                <span className="header">
                    <div className='task_filter_box' style={{ 
                    width: 'auto', backgroundColor: 'rgb(254 254 255)', border: '1px solid #cdcdcd',margin:"0px" }}>
                    <Popover
                        content={filterActivityPopOver}
                        title="Apply Filter"
                        trigger="click"
                        placement="bottom"
                        overlayClassName="Activity-Filter"
                        arrow={{ pointAtCenter: true }}
                    >
                        <Badge color="#1677ff" style={{ left: "0em", top: "3px" }} count={selectedActivityFilter.length}>
                          {/* edit task filter count no margin */}
                        <FontAwesomeIcon
                            style={{ color: 'rgb(124 139 173)', cursor: 'pointer' }}
                            color="white"
                            icon={faFilter}
                        />
                        </Badge>
                    </Popover>
                    </div>
                </span>
                
                </div>}
                {activitySection==1 && 
                <div className="additionalFeaturesOfActivity">
                    <span className="header">
                    </span> 
                    <span className="header">
                    </span>
                    <span className="header">
                    <div className="messageBehaviorSettings">
                        <Popover
                        content={
                            <div>
                            <Radio.Group onChange={(e) => handleMessageBehaviorChange(e)} defaultValue={messageBehavior}>
                                <Radio value="sendOnEnter">Send on Enter</Radio>
                                <Radio value="nextLineOnEnter">Next line on Enter</Radio>
                            </Radio.Group>
                            </div>
                        }
                        title="Message Behavior"
                        trigger="click"
                        placement="bottom"
                        >
                        <div style={{ cursor: 'pointer', padding: '10px' }}>
                            <FontAwesomeIcon icon={faCog} style={{ color: 'rgb(124 139 173)' }} />
                        </div>
                        </Popover>
                    </div>
                    </span>
                </div>
                }
            </div>
            <div  ref={timeline} className="Activity-Body" style={selectedTable != "tasks" ? {height: "87%"} : {}}>
                {taskModalState.action == "edit" &&
                activitySection == 0 && <>
                    <ActivitySection 
                        setScrollBottom={setScrollBottom} 
                        taskId={isSubTaskView ? taskData?.SubTaskROWID : taskData?.TaskROWID}
                        task={taskData} module={(isSubTaskView && selectedTable == 'pipelines') ? "SUBTASKTEMPLATE" :
                            (!isSubTaskView && selectedTable == 'pipelines') ? "TASKTEMPLATE" :
                            (isSubTaskView && selectedTable !== 'pipelines') ? "SUBTASK" : "TASK"}
                        refreshData={refreshData}
                        allTasksAndSubtasks={allTasksAndSubtasks}
                        viewTaskFunction={openTaskFromActivity}
                        selectedActivityFilter={selectedActivityFilter}
                        activityFilter={activityFilter}
                    />
                </>
                }
                {(taskModalState.action === "edit" && activitySection === 1) || taskListComment === true ? (
                    <TaskCommentSection 
                        taskId={isSubTaskView ? taskData?.SubTaskROWID : taskData?.TaskROWID}
                        taskType={taskData.hasOwnProperty("SubTaskROWID") ? 'SubTask' : 'Task'}
                        taskData={taskData}
                        allUsers={AllUsers}
                        allPipelineData={allPipelineData}
                        taskDataId = {viewTaskData?.Task?.TaskId}
                        messageBehavior={messageBehavior}
                        createTaskModal={true}
                    />
                    ) : null
                }
                {taskModalState.action == "edit" &&
                activitySection == 2 && <>
                    <StatusTimeline setScrollBottom={setScrollBottom} task={taskData} refresh={statusTimeline} />
                </>
                }
                {taskModalState.action == "edit" && activitySection == 3 && 
                    <>
                        <ReminderForTasks
                        task={taskData}
                        allUsers={AllUsers} 
                        refreshReminder={refreshReminder}
                        />
                    </>
                }
                { activitySection==3 && 
                    <div>
                        <div className='reminderPopover'>
                            <Popover
                                content={reminderContent()}
                                title=""
                                trigger="click"
                                open={reminderVisible}  
                                onOpenChange={setReminderVisible}
                                placement="right"
                                rootClassName='TaskReminderPopover'
                                >
                                <Button type='dashed'>Add Reminder</Button>
                            </Popover>
                        </div>
                    </div>
                }
                {taskModalState.action == "edit" && activitySection == 4 && 
                    <> 
                        <EmailChatSection getParams={getParams} location={location} 
                            taskROWID={taskData?.SubTaskROWID?taskData?.SubTaskROWID:taskData?.TaskROWID} 
                            taskType={taskData?.SubTaskROWID?'SubTask':'Task'}
                            clickedFromBody={false} 
                            handleNotificationHyperlink={handleNotificationHyperlink}
                            allTask={taskData}
                            viewTaskData={viewTaskData}
                            allUsers={AllUsers}
                            cacheDeals={AllDeals} 
                            dealObj={lookUpDeal}
                            fromtask={true}
                        />
                    </>
                }
            </div>
        </Col>
    );
}

export default TaskSidebarContentRenderer;